import React from "react";
import NumberFormat from "react-number-format";
import { Controller } from "react-hook-form";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { docso } from "utils/currencyFormat";

const InputDocTien = ({
  placeholder = "",
  labelClass = "label-control",
  inputClass = "form-control input-sm",
  wrapperClass = "form-group",
  inputWrapClass = "col-md-8",
  labelText = "",
  starRed = "",
  inputProps = {},
  error,
}) => {
  const renderTooltip = () => (
    <Tooltip id="button-tooltip">Simple tooltip</Tooltip>
  );
  return (
    <div className={wrapperClass}>
      <label className={labelClass}>
        {labelText} <span className="canh-bao-red">{starRed}</span>
      </label>
      <div className={inputWrapClass}>
        <Controller
          // as={NumberFormat}
          thousandSeparator
          prefix={""}
          name={inputProps.name}
          className={inputClass}
          control={inputProps.control}
          onChange={inputProps.onChange}
          value={inputProps.value}
          placeholder={placeholder}
          rules={inputProps.rules}
          defaultValue={inputProps.value}
          disabled={inputProps.disabled}
          readOnly={inputProps.readOnly}
          render={(props) => (
            <PopoversBootrap
              contentText={docso(inputProps.value)}
              titleText=""
              trigger={["hover", "focus"]}
              placement={"top"}
            >
              <NumberFormat
                {...props}
                onValueChange={(value) => {
                  props.onChange(value);
                  inputProps.onChange(value);
                }}
                className={inputClass}
                thousandSeparator
                readOnly={inputProps.readOnly}
                getInputRef={inputProps.getInputRef}
                value={inputProps.value}
                //isAllowed = {false}
              />
            </PopoversBootrap>
          )}
        />

        {/* {error && <span className="canh-bao-red">{error.message}</span>} */}
      </div>
    </div>
  );
};
export default InputDocTien;
